import React, { useMemo } from 'react'
import './ProviderRoleBadge.css'
import { ProviderWorkPosition } from '@constants/Providers'

const WORK_ROLE_STYLES: Record<ProviderWorkPosition, React.CSSProperties> = {
  [ProviderWorkPosition.DENTIST]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
  [ProviderWorkPosition.DENTAL_HYGIENIST]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [ProviderWorkPosition.DENTAL_ASSISTANT]: {
    backgroundColor: 'var(--indigo-200)',
    color: 'var(--indigo-700)',
  },
  [ProviderWorkPosition.DENTAL_THERAPIST]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [ProviderWorkPosition.DENTAL_NURSE]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
  [ProviderWorkPosition.DENTAL_TECHNICIAN]: {
    backgroundColor: 'var(--blue-600)',
    color: 'var(--gray-white)',
  },
  [ProviderWorkPosition.OFFICE_MANAGER]: {
    backgroundColor: 'var(--violet-200)',
    color: 'var(--violet-700)',
  },
  [ProviderWorkPosition.RECEPTIONIST]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [ProviderWorkPosition.BILLING_AND_INSURANCE_COORDINATOR]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [ProviderWorkPosition.ORTHODONTIC_ASSISTANT]: {
    backgroundColor: 'var(--violet-200)',
    color: 'var(--violet-700)',
  },
  [ProviderWorkPosition.ANESTHESIOLOGIST]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
  [ProviderWorkPosition.ORAL_SURGEON]: {
    backgroundColor: 'var(--orange-200)',
    color: 'var(--orange-700)',
  },
  [ProviderWorkPosition.ORAL_AND_MAXILLOFACIAL_SURGEON]: {
    backgroundColor: 'var(--orange-200)',
    color: 'var(--orange-700)',
  },
  [ProviderWorkPosition.ORAL_PATHOLOGIST]: {
    backgroundColor: 'var(--teal-200)',
    color: 'var(--teal-700)',
  },
  [ProviderWorkPosition.PERIODONTIST]: {
    backgroundColor: 'var(--violet-200)',
    color: 'var(--violet-700)',
  },
  [ProviderWorkPosition.ENDODONTIST]: {
    backgroundColor: 'var(--violet-200)',
    color: 'var(--violet-700)',
  },
  [ProviderWorkPosition.ORTHODONTIST]: {
    backgroundColor: 'var(--violet-200)',
    color: 'var(--violet-700)',
  },
  [ProviderWorkPosition.PROSTHODONTIST]: {
    backgroundColor: 'var(--violet-200)',
    color: 'var(--violet-700)',
  },
  [ProviderWorkPosition.PEDIATRIC_DENTIST]: {
    backgroundColor: 'var(--blue-100)',
    color: 'var(--blue-700)',
  },
}

interface ProviderRoleBadgeProps {
  workPosition: ProviderWorkPosition
}

const ProviderRoleBadge: React.FC<ProviderRoleBadgeProps> = ({
  workPosition,
}) => {
  const badgeStyle = useMemo(
    () =>
      WORK_ROLE_STYLES[workPosition] || {
        backgroundColor: '#E0E0E0',
        color: '#1b1d22',
      },
    [workPosition],
  )

  return (
    <span className="badge-status" style={badgeStyle}>
      {workPosition}
    </span>
  )
}

export default ProviderRoleBadge
